<template>
  <div class="loading" v-show="isShow">
    <div class="img">
      <img src="../assets/loading.gif" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: Boolean
  }
};
</script>
<style lang="scss" scoped>
.loading {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  background: #fff;
  left: 0;
  top: 0;
  .img {
    width: 30%;
    margin: 30vh auto;
    img {
      width: 100%;
    }
  }
}
</style>
